import { createUseStyles } from 'react-jss';
import { Shadows } from '../../../../foundation/colors/shadows/shadows/index.js';
import { CornerRadius } from '../../../../foundation/cornerRadius/cornerRadius/index.js';
import { BreakPointsMedia } from '../../../../foundation/responsive/responsive/index.js';

const useStyles = createUseStyles({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        verticalAlign: 'top',
        width: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.Default?.value?.rectangleWidth : sizes?.Default?.value?.size),
        height: ({ sizes }) => sizes?.Default?.value?.size,
        borderRadius: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.Default?.value?.radius : CornerRadius.circle),
        background: ({ skin }) => skin?.backgroundColor,
        boxShadow: ({ hasShadow }) => hasShadow && Shadows.tint2,
        [BreakPointsMedia.XXL]: {
            width: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.XXL?.value?.rectangleWidth : sizes?.XXL?.value?.size),
            height: ({ sizes }) => sizes?.XXL?.value?.size,
            padding: ({ sizes, skin }) => !skin?.isRectangle && `0 ${sizes?.XXL?.value?.paddingHorizontal}`,
            borderRadius: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.XXL?.value?.radius : CornerRadius.circle),
        },
        [BreakPointsMedia.XL]: {
            width: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.XL?.value?.rectangleWidth : sizes?.XL?.value?.size),
            height: ({ sizes }) => sizes?.XL?.value?.size,
            padding: ({ sizes, skin }) => !skin?.isRectangle && `0 ${sizes?.XL?.value?.paddingHorizontal}`,
            borderRadius: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.XL?.value?.radius : CornerRadius.circle),
        },
        [BreakPointsMedia.LG]: {
            width: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.LG?.value?.rectangleWidth : sizes?.LG?.value?.size),
            height: ({ sizes }) => sizes?.LG?.value?.size,
            padding: ({ sizes, skin }) => !skin?.isRectangle && `0 ${sizes?.LG?.value?.paddingHorizontal}`,
            borderRadius: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.LG?.value?.radius : CornerRadius.circle),
        },
        [BreakPointsMedia.MD]: {
            width: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.MD?.value?.rectangleWidth : sizes?.MD?.value?.size),
            height: ({ sizes }) => sizes?.MD?.value?.size,
            padding: ({ sizes, skin }) => !skin?.isRectangle && `0 ${sizes?.MD?.value?.paddingHorizontal}`,
            borderRadius: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.MD?.value?.radius : CornerRadius.circle),
        },
        [BreakPointsMedia.SM]: {
            width: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.SM?.value?.rectangleWidth : sizes?.SM?.value?.size),
            height: ({ sizes }) => sizes?.SM?.value?.size,
            padding: ({ sizes, skin }) => !skin?.isRectangle && `0 ${sizes?.SM?.value?.paddingHorizontal}`,
            borderRadius: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.SM?.value?.radius : CornerRadius.circle),
        },
        [BreakPointsMedia.XS]: {
            width: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.XS?.value?.rectangleWidth : sizes?.XS?.value?.size),
            height: ({ sizes }) => sizes?.XS?.value?.size,
            padding: ({ sizes, skin }) => !skin?.isRectangle && `0 ${sizes?.XS?.value?.paddingHorizontal}`,
            borderRadius: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.XS?.value?.radius : CornerRadius.circle),
        },
        [BreakPointsMedia.XXS]: {
            width: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.XXS?.value?.rectangleWidth : sizes?.XXS?.value?.size),
            height: ({ sizes }) => sizes?.XXS?.value?.size,
            padding: ({ sizes, skin }) => !skin?.isRectangle && `0 ${sizes?.XXS?.value?.paddingHorizontal}`,
            borderRadius: ({ sizes, skin }) => (skin?.isRectangle ? sizes?.XXS?.value?.radius : CornerRadius.circle),
        },
    },
    icon: {
        display: 'inline-block',
        verticalAlign: 'top',
        width: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.Default?.value?.iconSize : sizes?.Default?.value?.rectangleIconSize),
        height: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.Default?.value?.iconSize : sizes?.Default?.value?.rectangleIconSize),
        '& > path': {
            fill: ({ skin }) => skin?.color,
        },
        [BreakPointsMedia.XXL]: {
            width: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.XXL?.value?.iconSize : sizes?.XXL?.value?.rectangleIconSize),
            height: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.XXL?.value?.iconSize : sizes?.XXL?.value?.rectangleIconSize),
        },
        [BreakPointsMedia.XL]: {
            width: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.XL?.value?.iconSize : sizes?.XL?.value?.rectangleIconSize),
            height: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.XL?.value?.iconSize : sizes?.XL?.value?.rectangleIconSize),
        },
        [BreakPointsMedia.LG]: {
            width: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.LG?.value?.iconSize : sizes?.LG?.value?.rectangleIconSize),
            height: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.LG?.value?.iconSize : sizes?.LG?.value?.rectangleIconSize),
        },
        [BreakPointsMedia.MD]: {
            width: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.MD?.value?.iconSize : sizes?.MD?.value?.rectangleIconSize),
            height: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.MD?.value?.iconSize : sizes?.MD?.value?.rectangleIconSize),
        },
        [BreakPointsMedia.SM]: {
            width: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.SM?.value?.iconSize : sizes?.SM?.value?.rectangleIconSize),
            height: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.SM?.value?.iconSize : sizes?.SM?.value?.rectangleIconSize),
        },
        [BreakPointsMedia.XS]: {
            width: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.XS?.value?.iconSize : sizes?.XS?.value?.rectangleIconSize),
            height: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.XS?.value?.iconSize : sizes?.XS?.value?.rectangleIconSize),
        },
        [BreakPointsMedia.XXS]: {
            width: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.XXS?.value?.iconSize : sizes?.XXS?.value?.rectangleIconSize),
            height: ({ sizes, skin }) => (!skin?.isRectangle ? sizes?.XXS?.value?.iconSize : sizes?.XXS?.value?.rectangleIconSize),
        },
    },
}, {
    name: 'badge',
});

export { useStyles };
